module.exports = __webpack_public_path__ + "static/media/icon-login-parent-app.a1a2be4e.svg";